const statsNumbers = document.querySelectorAll(".stats__number");

statsNumbers.forEach((number) => {
    const cont = { val: 0 },
        newVal = number.textContent;
    gsap.to(cont, {
        scrollTrigger: ".stats",
        duration: 1.6,
        val: newVal,
        ease: "power4.out",
        onUpdate: function () {
            number.innerHTML = Math.round(cont.val * 10) / 10;
        }
    });
});
